import React, { useCallback, useEffect, useMemo, useState } from 'react';
import {
  CommonButton,
  DealerCodeCard,
  FilterButton,
  SearchInput,
  SingleSelect,
} from '../../../Components/CommonComponents';
import {
  Col,
  Container,
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  Row,
} from 'reactstrap';
import CustomSpinner from '../../../Components/CustomSpinner/CustomSpinner';
import excelImg from '../../../images/excel.png';
import closeImg from '../../../images/modalclose.png';
import './index.css';
import { getDealerwithStatus, getTerritories, updateActiveInactiveDealer } from '../../../constants/apiCalls';
import Pagination from '../../../Components/Pagination/Pagination';
import { DashBoardTitle } from '../../../Components/Title';
import { messages } from '../../../utils/constant-messages';
import lodash from 'lodash';
import ModalService from '../../../services/ModalService';
import { handleErrorMessage } from '../../../utils/utils';
import { useNavigate } from 'react-router-dom';
import Storage from '../../../services/Storage';
import { Permissions } from '../../../constants/Permissions';
import swal from 'sweetalert';
import { useSelector } from 'react-redux';
import AppHeader from '../../../Layout/AppHeader';
import AppSidebar from '../../../Layout/AppSidebar';

const ManageDealer = () => {

  const navigate = useNavigate();
  // const localPermission = Storage.getUserPermissionDetail();
  const { permissionArr } = useSelector(state => state.UserGetReducer)
  const localPermission = permissionArr;
  useEffect(() => {
    if (!localPermission.includes(Permissions.ADMIN_MANAGE_DEALER)) {
      navigate('/');
    }
  }, [...localPermission])

  let pageNo = useMemo(() => Storage.getManageDealerPage(), [Storage.getManageDealerPage()]);

  const [isLoading, setIsloading] = useState(false);

  const [count, setCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(Number(pageNo) ? Number(pageNo) : 1);
  const [pageSize, setPageSize] = useState(10);

  const [searchQuery, setSearchQuery] = useState('');
  const [userQuery, setUserQuery] = useState('');

  // Dealer Data on Card
  const [dealerData, setDealerData] = useState([]);

  // Filter Modal
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [territoryData, setTerritoryData] = useState([]);
  const [territoryVal, setTerritoryVal] = useState('');
  const [territoryId, setTerritoryId] = useState('');

  const [filterbtnActive, setFilterBtnActive] = useState(false);
  const [show, setShow] = useState(null);

  const sendQuery = (query) => {
    setSearchQuery(query);
  };
  const delayedQuery = useCallback(
    lodash.debounce((q) => sendQuery(q), 1000),
    []
  );

  const getTerritory = () => {
    getTerritories((res) => {
      const { data, success, error } = res;
      if (success === true) {
        setTerritoryData(data);
        setIsloading(false);
      } else if (success === false || success === 'undefined') {
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        setIsloading(false);
      }
      setIsloading(false);
    });
  };

  useEffect(() => {
    setIsloading(true);
    getDealerListData();
  }, [searchQuery, page, pageSize, territoryId])

  const getDealerListData = () => {
    let payload = {
      q: searchQuery,
      page: page || 1,
      pagesize: pageSize || 10,
      type: 'approve',
      start_date: '',
      end_date: '',
      territory_id: territoryId || '',
      adminOnly: false,
      manageDealer: true,
      is_download: false,
      application_upload: false,
    };
    getDealerwithStatus((res) => {
      const { data, success, error } = res;
      if (success === true) {
        if (data && data.data) {
          setDealerData(data.data);
        } else {
          setDealerData([]);
        }
        let count = Number(data.total_count);
        setCount(count);
        let totalPages = Math.ceil(count / pageSize);
        setTotalPages(totalPages);
        setIsloading(false);
      } else if (success === false || success === 'undefined') {
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        setIsloading(false);
      }
      setIsloading(false);
    }, payload);
  };

  // search Functionality
  const handleSearchChange = (e) => {
    let q = e.target.value;
    delayedQuery(q);
    setUserQuery(q);
    if (q) {
      setPage(1);
    } else {
      setPage(Number(pageNo));
    }
  };

  // Excel sheet
  const handleExcelSheet = () => {
    let payload = {
      q: searchQuery,
      page: page || 1,
      pagesize: 1000000,
      type: 'approve',
      start_date: '',
      end_date: '',
      territory_id: territoryId || '',
      adminOnly: false,
      manageDealer: true,
      is_download: true,
      application_upload: false,
    };
    getDealerwithStatus((res) => {
      const { data, success, error } = res;
      if (success === true) {
        window.open(data.file, '_blank');
        setIsloading(false);
      } else if (success === false || success === 'undefined') {
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        setIsloading(false);
      }
      setIsloading(false);
    }, payload);
  };

  const handlePageChange = useCallback(
    (page) => {
      setPage(page);
      Storage.setManageDealerPage(Number(page));
    },
    [page, pageSize]
  );

  const handleInputChange = useCallback(
    (e) => {
      let pageSize = parseInt(e.target.value);
      setPageSize(pageSize);
      setPage(1);
    },
    [page, pageSize]
  );

  const handleCardClick = (id) => {
    if (id === show) {
      setShow(null);
    } else {
      setShow(id);
    }
  };

  // Filter
  const handleFilterBtnClick = () => {
    getTerritory();
    setShowFilterModal(!showFilterModal);
    // setTerritoryVal('')
  };

  const handleChangeTerritory = (e) => {
    setTerritoryVal(e.target.value);
  };

  const handleResetFilter = () => {
    setTerritoryVal('');
    setTerritoryId('');
    setShowFilterModal(false);
    setFilterBtnActive(false);
    setPage(1);
    Storage.setManageDealerPage(1);
  };

  const handleApplyFilter = (e) => {
    e.preventDefault();
    if (territoryVal) {
      setTerritoryId(territoryVal);
      setShowFilterModal(false);
      setFilterBtnActive(true);
      setPage(1);
      Storage.setManageDealerPage(1);
    }
  };

  const handleChangeUserSwitch = (e, item) => {
    if (item.id) {
      let index = dealerData.findIndex((e) => e.id === item.id);
      dealerData[index].is_active = e;
      setDealerData([...dealerData]);
    }

    let payload = {
      dealer_id: item.id,
      is_active: e,
    }
    setIsloading(true);
    swal({
      title: e === true ? 'Active User' : 'Inactive User',
      text: `Are you sure you want to ${e === true ? 'Acitve' : 'Inactive'} this dealer?`,
      icon: 'warning',
      buttons: ['No', 'Yes'],
    }).then((isConfirm) => {
      if (isConfirm) {
        setIsloading(true);
        if (item.id) {
          let index = dealerData.findIndex((e) => e.id === item.id);
          dealerData[index].is_active = e;
          setDealerData([...dealerData]);
        }

        updateActiveInactiveDealer((res) => {
          const { success, message, error } = res;
          if (success === true) {
            ModalService.openAlert('', message, 'success');
            setIsloading(false);
            getDealerListData();
          } else if (success === false || success === 'undefined') {
            ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
            getDealerListData();
            setIsloading(false);
          }
          setIsloading(false);
        }, payload);
      } else {
        setIsloading(false)
        if (item.id) {
          let index = dealerData.findIndex((e) => e.id === item.id);
          dealerData[index].is_active = !e;
          setDealerData([...dealerData]);
        }
      }
    });
  }



  return (
    <>
      <AppHeader />
      <div className='app-main'>
        <AppSidebar />
        <div className='app-main__outer'>
          <div className='app-main__inner rms-wrapper'>
            <div id='manageDealer'>
              {isLoading && <CustomSpinner />}
              <div className='pageWrapper'>
                <Container fluid>
                  <Row>
                    <Col xs={12}>
                      <div className='pageheader'>
                        <DashBoardTitle dashBorardName='Manage Dealer' className="lightTitle" />
                      </div>
                    </Col>
                    <Col xs={12}>
                      <div className='searchArea'>
                        <div className='searchBlock'>
                          <SearchInput
                            // parentStyle={{maxWidth: '200px'}}
                            InputProps={{
                              name: 'search',
                              placeholder:
                                'Search by Dealership, Owner, Dealer Code or Mobile No.',
                            }}
                            onChange={handleSearchChange}
                            value={userQuery}
                          />
                          <FilterButton
                            onClick={handleFilterBtnClick}
                            className={
                              filterbtnActive ? 'activeFilterBtn' : 'inActiveFilterBtn'
                            }
                          />
                        </div>
                        <img
                          src={excelImg}
                          alt='excel'
                          width={35}
                          height={35}
                          className='cursorPointer excelIcon'
                          onClick={handleExcelSheet}
                        />
                      </div>
                    </Col>
                  </Row>
                  {dealerData && dealerData.length > 0 ? (
                    <Row>
                      <Col xs={12}>
                        {dealerData.map((elem, index) => {
                          return (
                            <DealerCodeCard
                              onClick={() => handleCardClick(elem.id)}
                              show={show === elem.id}
                              elem={elem}
                              key={index}
                              getDealerListData={getDealerListData}
                              handleChangeUserSwitch={(e) => handleChangeUserSwitch(e, elem)}
                              cardClassName={'blueText'}
                            />
                          );
                        })}
                      </Col>
                      <Col xs={12}>
                        <div className='paginationWrapper'>
                          <span className='page-select-title'>Rows per page:</span>
                          &nbsp;&nbsp;
                          <select
                            className='form-control rows-per-page-select'
                            name='pageSize'
                            value={pageSize}
                            onChange={(e) => handleInputChange(e)}
                          >
                            <option key='5' value='5'>
                              5 Rows
                            </option>
                            <option key='10' value='10'>
                              10 Rows
                            </option>
                            <option key='15' value='15'>
                              15 Rows
                            </option>
                            <option key='20' value='25'>
                              25 Rows
                            </option>
                            <option key='25' value='30'>
                              30 Rows
                            </option>
                            <option key='30' value='50'>
                              50 Rows
                            </option>
                          </select>
                          &nbsp;&nbsp;
                          <div className='pageList'>
                            <Pagination
                              margin={2}
                              page={page}
                              count={parseInt(totalPages)}
                              pageSize={pageSize}
                              totalRecords={parseInt(count)}
                              onPageChange={handlePageChange}
                            ></Pagination>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  ) : (
                    <Row>
                      <Col xs={12}>
                        {messages.COMMON.NO_RECORD_MATCH}
                      </Col>
                    </Row>
                  )}
                </Container>
              </div>
              {/* Filter Modal */}
              <Modal
                isOpen={showFilterModal}
                toggle={() => setShowFilterModal(!showFilterModal)}
                centered
                className='filterModal'
                id='filterDealerModal'
              >
                <ModalBody className='p-0'>
                  <div className='ModalArea'>
                    <Container>
                      <Row>
                        <Col xs={12}>
                          <div className='modalHeading'>
                            <div className='title'>Filter</div>
                            <div className='closeButton'>
                              <img
                                src={closeImg}
                                alt='close'
                                onClick={() => setShowFilterModal(!showFilterModal)}
                              />
                            </div>
                          </div>
                        </Col>
                        <Col xs={12}>
                          <Form onSubmit={handleApplyFilter}>
                            <FormGroup>
                              <Label className='common-input-label'>
                                Territory<span className='required'>*</span>
                              </Label>
                              <SingleSelect
                                // disabled={editId}
                                id='territoryType'
                                required={true}
                                name='territoryType'
                                value={
                                  territoryVal === null || territoryVal === 'undefined'
                                    ? ''
                                    : territoryVal
                                }
                                onChange={(e) => handleChangeTerritory(e)}
                                options={territoryData}
                                label={'name'}
                                selectedValueKey={'id'}
                              />
                            </FormGroup>
                            <div className='btnGroup'>
                              <CommonButton
                                name='Reset'
                                onClick={handleResetFilter}
                                btnClass={'btnSecondary'}
                                type='button'
                              />
                              <CommonButton
                                name='Apply'
                                btnClass={'btnPrimary'}
                                type='submit'
                              />
                            </div>
                          </Form>
                        </Col>
                      </Row>
                    </Container>
                  </div>
                </ModalBody>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageDealer;
